export const GeneralPoints = [
  `Have at least 1 question, but no more than 8 per task.`,
  `Ensure no question is left blank (at the least have "Read the above").`,
  `Don't leave unused space at the end of task descriptions.`,
  `Ensure images are an appropriate size.`,
];
